import { render, staticRenderFns } from "./dialog-sharelink.vue?vue&type=template&id=a24fbb96&"
import script from "./dialog-sharelink.vue?vue&type=script&lang=js&"
export * from "./dialog-sharelink.vue?vue&type=script&lang=js&"
import style0 from "./dialog-sharelink.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports